module.exports = __webpack_public_path__ + "static/img/附件七.f3d7927.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index/附件七.jpg
// module id = jrjz
// module chunks = 1